module.exports = __webpack_public_path__ + "static/media/KE.d997d00c.svg";